// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__29Gkf","list":"PatternAutocomplete_list__1PAzR"};